import { TIME_ENTRY_TYPE_OPTIONS } from "../constants";

export const TIME_ENTRY_WORK_FIELDS = {
template: {
    type: "template-select",
    label: "Template",
    placeholder: "Select a time entry template...",
    formOnly: true,
    formSpan: 3,
    templateSelectConfig: {
      templateType: "time-entry",
      showClearOption: true,
      fieldMappings: {
        description: "description",
        type: "entry_type",
        billable_rate: "billable_rate",
        tags: "tags",
      },
    },
    excludeFromApi: true,
    // Table properties
    editable: true,
    hideable: true,
    resizable: true,
    width: 260,
    mobileDetailSectionId: "work",
  },
date_worked: {
    type: "date-worked",
    label: "Date Worked",
    placeholder: "Select date",
    required: true,
    autoFill: true,
    formSpan: 1,
    validation: {
      required: "Date worked is required.",
    },
    // Table properties
    sortable: true,
    filterable: true,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: true,
    filterType: "dateRange",
    width: 120,
    minWidth: 100,
    maxWidth: 150,
    icon: "Calendar",
    groupable: true,
    groupingOptions: {
      dateGranularity: "month",
    },
    // Client work-transparency: clients see the time logged on their own tickets.
    allowedRoles: ["client_user", "wtc_employee", "wtc_admin"] as string[],
    showOnCard: true,
    cardSpan: 1,
    mobileDetailSectionId: "work",
  },
ticket_id: {
    type: "ticket-select",
    label: "Ticket",
    isForeignKey: true,
    foreignKey: {
      referencedTable: "tickets",
      referencedColumn: "id",
      constraintName: "time_entries_ticket_id_fkey",
      onDelete: "SET NULL",
      onUpdate: "NO ACTION",
      relationKind: "many-to-one",
    },
    placeholder: "Search for ticket...",
    required: false,
    formSpan: 3,
    ticketSelectConfig: {
      showModal: true,
      limit: 20,
    },
    // Table properties - wider to fit inline icon actions
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: true,
    filterType: "exact",
    width: 240,
    minWidth: 240,
    maxWidth: 280,
    icon: "Ticket",
    // Clients see which of their tickets the time was logged against.
    allowedRoles: ["client_user", "wtc_employee", "wtc_admin"] as string[],
    showOnCard: true,
    cardSpan: 2,
    showRowActions: true,
    mobileDetailSectionId: "context",
  },
company_id: {
    type: "select",
    label: "Company",
    isForeignKey: true,
    foreignKey: {
      referencedTable: "companies",
      referencedColumn: "id",
      constraintName: "time_entries_company_id_fkey",
      onDelete: "NO ACTION",
      onUpdate: "NO ACTION",
      relationKind: "many-to-one",
    },
    placeholder: "Company (auto-derived from ticket)",
    required: false,
    excludeFromApi: true, // Don't include in API submission - it's auto-populated
    // Table properties
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: false, // Read-only since it's derived from ticket
    filterType: "company-select",
    width: 200,
    minWidth: 150,
    maxWidth: 300,
    icon: "Building2",
    // Clients see their own company on their time entries.
    allowedRoles: ["client_user", "wtc_employee", "wtc_admin"] as string[],
    groupable: true,
    showOnCard: true,
    cardSpan: 1,
    mobileDetailSectionId: "context",
  },
description: {
    type: "textarea",
    label: "Description",
    placeholder: "Describe the work performed...",
    required: true,
    formSpan: 3,
    validation: {
      required: "Description is required.",
    },
    // Table properties
    sortable: false,
    filterable: false,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: true,
    width: 300,
    minWidth: 200,
    maxWidth: 400,
    icon: "FileText",
    // Clients see the description of work performed on their tickets.
    allowedRoles: ["client_user", "wtc_employee", "wtc_admin"] as string[],
    showOnCard: true,
    cardSpan: 2,
    mobileDetailSectionId: "work",
  },
hours: {
    type: "text",
    label: "Hours",
    placeholder: "e.g. 2.5",
    required: true,
    formSpan: 1,
    validation: {
      required: "Hours are required.",
      min: 0.1,
      max: 24,
    },
    // Table properties
    sortable: true,
    filterable: true,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: true,
    filterType: "numberRange",
    width: 100,
    minWidth: 80,
    maxWidth: 120,
    icon: "Clock",
    groupable: true,
    groupingOptions: {
      numberRanges: {
        ranges: [
          { min: 0, max: 1, label: "0-1 hours" },
          { min: 1, max: 2, label: "1-2 hours" },
          { min: 2, max: 3, label: "2-3 hours" },
          { min: 3, max: 4, label: "3-4 hours" },
          { min: 4, max: 10, label: "4-10 hours" },
          { min: 10, max: null, label: "10+ hours" },
        ] as { min: number; max: number | null; label: string }[],
      },
    },
    // Client work-transparency: clients see the time logged on their own tickets.
    allowedRoles: ["client_user", "wtc_employee", "wtc_admin"] as string[],
    showOnCard: true,
    cardSpan: 1,
    mobileDetailSectionId: "work",
  },
entry_type: {
    type: "select",
    label: "Entry Type",
    formSpan: 1,
    options: TIME_ENTRY_TYPE_OPTIONS.map((option) => ({
      label: option.label,
      value: option.value,
    })),
    validation: {
      required: false,
    },
    // Table properties
    sortable: true,
    filterable: true,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: true,
    filterType: "exact",
    width: 140,
    minWidth: 120,
    maxWidth: 180,
    icon: "Settings",
    groupable: true,
    // Client work-transparency: clients see the time logged on their own tickets.
    allowedRoles: ["client_user", "wtc_employee", "wtc_admin"] as string[],
    showOnCard: true,
    cardSpan: 1,
    mobileDetailSectionId: "work",
  }
} as const;
